import { render } from "./UnsplashView.vue?vue&type=template&id=3ec79d7d"
import script from "./UnsplashView.vue?vue&type=script&lang=js"
export * from "./UnsplashView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__